import React from 'react';

import withContextConsumer from './withContextConsumer';
import { IClientConfig } from '../../types/types';

const { Provider: ConfigProvider, Consumer: ConfigConsumer } =
  React.createContext<IClientConfig>(null);

const withConfig = withContextConsumer<IClientConfig>(
  ConfigConsumer,
  (config) => ({
    config,
  }),
);

interface IWithConfigProps {
  config: IClientConfig;
}

export { ConfigProvider, ConfigConsumer, withConfig, IWithConfigProps };
